import React from "react";
import { Button, Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";
import { DualAxisChart } from "../../../charts/CompositChart";
import { DUAL_AXIS_COLORS, STATUS_COLORS, ACCENT, MUTED_BAR } from "../../../charts/colors";

function ReAttemptAdherence({ data }) {

    const [showCount, setShowCount] = React.useState(false)

    const chartOptions = showCount
        ? {
            layout: 'horizontal',
            xaxis: 'name',
            showLabels: true,
            legendAlign: 'left',
            yaxis: {
                left: {
                    label: '# Shipment',
                    data: [
                        {
                            dataKey: 'totalReattemptRequested',
                            label: 'Reattempt Requested',
                            chartType: 'line',
                            fill: DUAL_AXIS_COLORS.SECONDARY,
                        },
                        {
                            dataKey: 'reattemptDelivered',
                            label: 'Delivered',
                            chartType: 'line',
                            fill: STATUS_COLORS.DELIVERED,
                        },
                        {
                            dataKey: 'actualTotalReattempt',
                            label: 'Actual Re-attempt',
                            chartType: 'line',
                            fill: ACCENT.blue,
                        },
                    ],
                },
                right: {
                    label: 'Adherence %',
                    domain: [0, 100],
                    data: [
                        {
                            dataKey: 'reattemptAdherence',
                            label: 'Adherence %',
                            chartType: 'bar',
                            fill: MUTED_BAR,
                            fillOpacity: 0.65,
                            unit: '%',
                        },
                    ],
                },
            },
        }
        : {
            layout: 'horizontal',
            xaxis: 'name',
            showLabels: true,
            legendAlign: 'left',
            yaxis: {
                left: {
                    label: 'Adherence %',
                    domain: [0, 100],
                    data: [
                        {
                            dataKey: 'reattemptAdherence',
                            label: 'Adherence %',
                            chartType: 'bar',
                            fill: MUTED_BAR,
                            fillOpacity: 0.75,
                            unit: '%',
                        },
                    ],
                },
            },
        }

    return (
        <Card elevation={1}>
            <CardHeader
                title="Re-attempt Adherence" subheader={
                    <Typography variant="body2">
                        The chart shows the data on the adherence of re-attempt requests to NDR shipments by the courier partners.
                        <br /> A poor re-attempt adherence percentage indicates that the re-attempt action is not effective.
                    </Typography>
                }
                action={(<Button
                    size="small"
                    disableElevation
                    onClick={() => setShowCount(st => !st)}
                    variant={showCount ? "contained" : "outlined"}
                    sx={{ mr: 1 }}
                >
                    Show Count
                </Button>)}
            />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <DualAxisChart data={data} chartOptions={chartOptions} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default ReAttemptAdherence;